<template>
    <v-flex class="col-md-4">
        <v-select class="col-md-4">

        </v-select>
    </v-flex>
</template>

<script>
    import { getOpenIds } from "../../api/routes";
    export default {
        name: "OpenIds",
        methods: {
            OpenIds() {
                getOpenIds()
                .then(resp => {
                    console.log(resp)
                })
                .catch(error => {
                    console.log(error)
                });
            }
        },
        beforeMount() {
            this.OpenIds();
        }
    }
</script>

<style scoped>

</style>
